
// fangT 房态删选
const setFangTSearchOption = (str) => {
  localStorage.setItem('fangTSearchOption', str)
}

const getFangTSearchOption = () => {
  return localStorage.getItem('fangTSearchOption') || ''
}

const removeFangTSearchOption = () => {
  localStorage.removeItem('fangTSearchOption')
}

const setCateringOrderSearchOptions = (str) => {
  localStorage.setItem('cateringOrderSearchOptions', str)
}

const getCateringOrderSearchOptions = () => {
  return localStorage.getItem('cateringOrderSearchOptions') || ''
}

const removeCateringOrderSearchOptions = () => {
  localStorage.removeItem('cateringOrderSearchOptions')
}



// 清空必要的localStorage
const clearUserLocal = () => {
  localStorage.removeItem('fangTSearchOption')
  localStorage.removeItem('cateringOrderSearchOptions')
}

module.exports = {
  setFangTSearchOption,
  getFangTSearchOption,
  removeFangTSearchOption,

  setCateringOrderSearchOptions,
  getCateringOrderSearchOptions,
  removeCateringOrderSearchOptions,

  clearUserLocal,
}



// WEBPACK FOOTER //
// ./src/conf/userLocal.js